<template>
  <VuePerfectScrollbar
    v-loading="isLoading"
    style="
      height: calc(100vh - 12.1rem - 30px);
      background-color: white;
      padding: 1rem;
    "
  >
    <EnableTwoFactorAuthentications />
    <!-- <AdvancedSecurity/> -->
    <ChangePassword />
  </VuePerfectScrollbar>
</template>

<script>
// CSS

//Lib

// Api

// Constant

// Extend
import base from "@/scripts/base";

// Component
import lazyLoadComponent from "@/scripts/lazyLoadComponent";
import SkeletonBox from "@/components/SkeletonBoxWithoutLoading";
//import ChangePassword from "@/views/component/Auth/ChangePassword";

// Function

export default {
  extends: base,

  components: {
      ChangePassword: lazyLoadComponent({
            componentFactory: () => import("@/views/component/Auth/ChangePassword"),
            loading: SkeletonBox,
      }),
      AdvancedSecurity: lazyLoadComponent({
            componentFactory: () => import("@/views/component/Auth/AdvancedSecurity"),
            loading: SkeletonBox,
      }),
      EnableTwoFactorAuthentications: lazyLoadComponent({
          componentFactory: () => {
              return new Promise((resolve, reject) => {
                  setTimeout(() => {
                      import("@/views/component/Auth/EnableTwoFactorAuthentication")
                          .then((component) => resolve(component))
                          .catch((error) => reject(error));
                  }, 500);
              });
          },
            loading: SkeletonBox,
      }),
  },

  data() {
    return {};
  },

  created() {},

  methods: {
    //#region Processing event
    processingEvent(param) {
      this[param.event](param.data);
    },
    //#endregion
  },
};
</script>